module.exports = __webpack_public_path__ + "img/icon_metago.fe0da597.svg";